import { render, staticRenderFns } from "./tushan.vue?vue&type=template&id=571050a9&scoped=true&"
import script from "./tushan.vue?vue&type=script&lang=js&"
export * from "./tushan.vue?vue&type=script&lang=js&"
import style0 from "./tushan.vue?vue&type=style&index=0&id=571050a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571050a9",
  null
  
)

export default component.exports